const DUMMY_PROJECTS=[
    {
        projectTitle:'Job Recommendation Portal',
        description: 'A Portal to help student for search and apply for their dream Jobs. currently in working face....',
        sourceLink:'https://github.com/aayushpawar07/JobRecommendationPortal.git',
        lastUpdated:'Sep 10 2024'
    },
    {
        projectTitle:' Card Management system',
        description: 'Java Based fullstack project to do crud operation and also the use of spring security for login sign up',
        sourceLink:'https://github.com/aayushpawar07/JobRecommendationPortal.git',
        lastUpdated:'Sep 10 2024'
    },
    

    {
        projectTitle:'Bill Splitter',
        description: 'A JavaScript based website to split the bill among friends. It takes the total amount and number of people and calculates the amount each person has to pay.',
        sourceLink:'https://github.com/aayushpawar07/Bill-Spliter.git',
        lastUpdated:'Dec 30 2024'
    },
   
    
    
    {
        projectTitle:'Password Generator',
        description: 'A website where you can generate strong Passwords to use as Authentication in different websites and apps based on the difficulty level set by you. ',
        sourceLink:'https://github.com/aayushpawar07/Password-Jenerator.git',
        lastUpdated:'Sep 24 2024'
    },
    {
        projectTitle:'Shopping Cart',
        description: 'In this i have made a shopping card in which i am fetching product list from an api and displaing products and its detalis. User can add products to cart and can see the total amount of products in cart.',
        sourceLink:'https://github.com/aayushpawar07/ShoppingCard.git',
        lastUpdated:'Sep 10 2024'
    },
   


   
];
const ProjectsData={DUMMY_PROJECTS};
export default ProjectsData;